import React from "react";
import { Card, Carousel } from "react-bootstrap";
import { testimonials } from "../../constants/testimonials";
import "./styles.css";
import styled from "styled-components";
import amar from "../../images/testimonials/amar_kamble.jpeg";
import aniket from "../../images/testimonials/aniket_kadam.jpeg";
import dhanaji from "../../images/testimonials/dhanaji_pawar.jpeg";
import pankaj from "../../images/testimonials/pankaj_oswal.jpeg";
import rajesh from "../../images/testimonials/rajesh_pathre.jpeg";

const WrapperCard = styled(Card)`
  padding: 0 1rem;
  background-color: #3b7597;
  border-radius: 0;
  overflow: hidden;

  @media (max-width: 600px) {
    padding: 0 8px;
  }
`;

const StyledTestimonialCard = styled(Card)`
  width: 100%;
  max-width: 40rem;

  min-height: 18rem;

  border-radius: 20px;

  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    min-height: 20rem;
    border-radius: 16px;
  }

  @media (max-width: 480px) {
    min-height: 22rem;
    padding: 0.5rem;
  }
`;

const CardContent = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  text-align: center;

  overflow: hidden;
`;

const ReviewTxt = styled.p`
  font-weight: 600;
  font-size: 1.1rem;
  font-style: italic;
  color: #f4abab;

  width: 100%;

  min-height: 90px;

  display: flex;
  align-items: center;
  justify-content: center;

  word-break: break-word;
  overflow-wrap: break-word;

  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 0.95rem;
    min-height: 110px;
  }

  @media (max-width: 480px) {
    font-size: 0.85rem;
    min-height: 120px;
  }
`;

const NameText = styled.h5`
  color: #0f627e;

  min-height: 32px;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;

  margin: 0.5rem 0;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const TestimonialImg = styled.img`
  border-radius: 50%;
  width: 75px;
  height: 75px;
  object-fit: cover;
  flex-shrink: 0;

  @media (max-width: 480px) {
    width: 65px;
    height: 65px;
  }
`;

function Testimonials() {
  const ImgArray = [rajesh, aniket, amar, dhanaji, pankaj];

  return (
    <>
      <h3 className="header-style">Customer Testimonials</h3>

      <WrapperCard>
        <Card.Body>
          <Carousel controls={true} indicators={true} interval={2500}>
            {testimonials.map((testimonial, index) => (
              <Carousel.Item key={index}>
                <div className="d-flex justify-content-center py-4 px-2">
                  <StyledTestimonialCard className="shadow border-0 p-4">
                    <Card.Body>
                      <CardContent>
                        <ReviewTxt>“{testimonial.review}”</ReviewTxt>

                        <NameText>{testimonial.name}</NameText>

                        <TestimonialImg src={ImgArray.at(index)} />
                      </CardContent>
                    </Card.Body>
                  </StyledTestimonialCard>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </Card.Body>
      </WrapperCard>
    </>
  );
}

export default Testimonials;
